import { Box, Flex, Icon, Text, BoxStyleSpaceScale } from '@fullstory/components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const PartialPeriodWarning = ({
  className,
  padding = [4, 8],
}: {
  className?: string;
  padding?: BoxStyleSpaceScale;
}) => (
  <Box className={className} padding={padding} data-component="PartialPeriodWarning">
    <Flex justifyContent="flex-start" gap={8} alignItems="center">
      <Icon size={16} name="warning-fill" color="warning" />
      <Text color="warning" appearance="bodySmall">
        <FormattedMessage defaultMessage=" Indicates partial period" id="Uiy1aH" />
      </Text>
    </Flex>
  </Box>
);
